/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
}

function GooglePlayIcon(props: IProps) {
  const { ...rest } = props;

  return (
    <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clip-path="url(#clip0_18119_39991)">
        <path
          d="M12.6091 14.302L0.111816 27.4622C0.25216 27.9621 0.504362 28.4232 0.849143 28.8101C1.19392 29.197 1.62216 29.4996 2.1011 29.6946C2.58005 29.8897 3.09703 29.9721 3.61253 29.9356C4.12803 29.8991 4.6284 29.7446 5.07539 29.4839L19.1372 21.4344L12.6091 14.302Z"
          fill="#EA4335"
        />
        <path
          d="M25.2461 12.065L19.1653 8.56421L12.3206 14.6013L19.1931 21.4154L25.2276 17.9522C25.7622 17.6708 26.21 17.2478 26.5224 16.7289C26.8348 16.21 27 15.6151 27 15.0085C27 14.402 26.8348 13.8071 26.5224 13.2882C26.21 12.7693 25.7622 12.3462 25.2276 12.0649L25.2461 12.065Z"
          fill="#FBBC04"
        />
        <path
          d="M0.11183 2.48975C0.0363343 2.77044 -0.00126823 3.06007 3.26283e-05 3.35084V26.6011C0.00077809 26.8917 0.0383458 27.1811 0.11183 27.4623L13.0376 14.639L0.11183 2.48975Z"
          fill="#4285F4"
        />
        <path
          d="M12.7023 14.976L19.1652 8.56442L5.122 0.477356C4.59363 0.166353 3.9927 0.00164583 3.3804 6.50145e-06C1.86091 -0.0029617 0.525043 1.01068 0.111816 2.48047L12.7023 14.976Z"
          fill="#34A853"
        />
      </g>
      <defs>
        <clipPath id="clip0_18119_39991">
          <rect width="27" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GooglePlayIcon;
